import { Sine, TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import * as SoundEffect from "../Data/SoundEffect";
import * as VoiceOver from "../Data/VoiceOver";
import { ColourRampFilter } from "../Filters/ColourRampFilter";
import { Button } from "../GameObjects/Button";

export class HieroglyphColourButton extends Button {
    private static readonly COLOUR_COUNT: number = 10;
    private _buttonIndex: number;
    private _colourIndex: number;
    private _iconOutline: PIXI.Sprite;
    private _filter!: ColourRampFilter;
    private _colourRamp!: PIXI.Texture;

    constructor(pCallback: () => void, pIndex: number) {
        super(pCallback, "button0" + pIndex, Constants.SPRITESHEET_HIERO_PREFIX + "00");
        this._buttonIndex = pIndex;
        this._colourIndex = -1;

        this._icon = HLF.PixiUtils.makeSprite("button04-ramp", Constants.SPRITESHEET_HIERO_PREFIX + "00");
        this._visuals.addChild(this._icon);

        this._iconOutline = HLF.PixiUtils.makeSprite("button04-border", Constants.SPRITESHEET_HIERO_PREFIX + "00");
        this._visuals.addChild(this._iconOutline);

        this._clickedSFX = SoundEffect.UI_CLICK;
    }

    public get colourIndex(): number {
        return this._colourIndex;
    }

    public onFocusActivated(): void {
        if (this.interactive) {
            this.incrementColourIndex();
            this.updateIcon();
        }
        super.onFocusActivated();
    }

    public setupForOnboarding(pIsOnboarding: boolean): void {
        this._hoverVO = pIsOnboarding ? (VoiceOver.HIERO_BUTTON_PREFIX + "04") : undefined;
    }

    protected onPointerUp(pEvent: PIXI.interaction.InteractionEvent): void {
        if (this._eventData !== undefined) {
            this.incrementColourIndex();
            this.updateIcon();
            super.onPointerUp(pEvent);
        }
    }

    protected updateIcon(): void {
        if (this._colourIndex === -1) {
            this._icon!.filters = [];
        }
        else {
            const texture: string = "colour-ramp-0" + this._colourIndex;
            this._colourRamp = PIXI.loader.resources[texture].texture;
            if (this._filter === undefined) {
                this._filter = new ColourRampFilter(this._colourRamp);
            }
            else {
                this._filter.uniforms.uRamp = this._colourRamp;
            }
            this._icon!.filters = [ this._filter ];
        }
    }

    protected playHoverVO(): void {
        super.playHoverVO();
        if (this._hoverVO !== undefined && this._canPlayVo) {
            this._hoverVO = undefined;
        }
    }

    private incrementColourIndex(): void {
        ++this._colourIndex;
        if (this._colourIndex >= HieroglyphColourButton.COLOUR_COUNT) {
            this._colourIndex = -1;
        }
    }
}
